const operatorList = [

  {
    label: 'не определен',
    value: '',
    colorId: "#FC05E3"
  },

  {
    label: 'СТУДИЯ',
    value: '85252645',
    colorId: "#ff0000"
  },


  {
    label: 'Каюмов Ильдар',
    value: '245168122',
    colorId: "#0838E0"
  },

  {
    label: 'Нугуманов Роман',
    value: '208476624',
    colorId: "#FCC605"
  },

  {
    label: 'Федотов Виталий',
    value: '186546719',
    colorId: '#099806'
  },

  {
    label: 'Никишина Анастасия',
    value: '244643690',
    colorId: "#05FCED"
  },

  {
    label: 'Яковлев Игорь',
    value: '486408353',
    colorId: "#FC7C05"
  },

  {
    label: 'Шуняев Андрей',
    value: '172933695',
    colorId: "#BCFC05"
  },

  {
    label: 'Циглов Тимур',
    value: '1704560609',
    colorId: "#05FCFC"
  },

  {
    label: 'Емаев Сергей',
    value: '1267512293',
    colorId: "#05FCFC"
  },
  {
    label: 'Курбанов Артур',
    value: '449679363',
    colorId: "#fce705"
  }

]

export default operatorList